import * as React from 'react';

import Coach from 'components/atoms/Coach';
import { ImageProps } from 'components/atoms/Image/Image';
import { CoachIsEnumType } from 'components/molecules/CoachSelector';
import PoolTeaser from 'components/organisms/Pool/elements/PoolTeaser/PoolTeaser';
import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';

export type CustomWorkoutContainerPropsType = {
	coach: CoachIsEnumType | null;
};

type CustomWorkoutPropsType = CustomWorkoutContainerPropsType & {};

const CustomWorkout = ({ coach }: CustomWorkoutPropsType) => (
	<div className="container">
		<div className="row">
			<div className="col-xs-12">
				<div className="o-pool__teasers">
					<PoolTeaser
						image={(undefined as any) as ImageProps /* has no image! */}
						modifier="workout"
						tag={i18n('react.impulsCoach.views.pools.workout.custom.tag')}
						headline={i18n('react.impulsCoach.views.pools.workout.custom.title')}
						link={compileDynamicRoute(i18n('react.impulsCoach.routes.poolCustomWorkout.href'), {
							selectedPool: i18n(`react.impulsCoach.routes.pool.selectedPool.workout.href`),
						})}
						customImage={
							<div className="o-pool-teaser__coach-box">
								<div className="o-pool-teaser__coach-wrap">
									<Coach coach={coach || 'MIA'} gesture="front-perfect" />
								</div>
							</div>
						}
					/>
				</div>
			</div>
		</div>
	</div>
);

export default CustomWorkout;
